import { Component, Vue } from 'vue-property-decorator';
import { AccountService } from '@/services/checkout';
import { redirectLogin } from '@/views/checkout/utilities/user';

@Component
export default class Account extends Vue {
    login(selectedMethodId: number, lang: string) {
        redirectLogin(selectedMethodId, lang);
    }

    logout() {
        AccountService.logout();
    }
}
